import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TokenService } from './token.service';
import { AuthService } from '../services/auth.service';


@Injectable()
export class ApiRequestInterceptor implements HttpInterceptor {

  constructor(private tokenService: TokenService, private authService: AuthService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.tokenService.token;
    if (token) {
      request = request.clone({ setHeaders: { Authorization: this.tokenService.token } });
    }

    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => event,
        (error: any) => this.handleError(error)
      )
    );
  }

    private handleError(error: any): void {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401 || error.status === 0) {
          this.authService.logout();

        }
      }
    }


}
